import React, { Component } from 'react';
import Card from 'react-bootstrap/Card';
const $ = require('jquery');

// $.DataTable = require('datatables.net');
// require('datatables.net-responsive');
// import 'datatables.net-dt/css/jquery.dataTables.min.css';
// require('datatables.net-buttons/js/dataTables.buttons.min');
const jzip = require('jzip');
// require('datatables.net-buttons/js/buttons.html5.min');
// import 'datatables.net-buttons-dt/css/buttons.dataTables.css';
// // import ModalItem from '../modal/ModalItem';
window.JSZip = jzip;
const id = 'id' + Math.random().toString(16).slice(2);

const columns = [
  {
    title: 'DT',
    data: 'DATE_INSERT'
  },
  {
    title: '#',
    data: 'ROW_NO'
  },
  {
    title: 'SHOP_ID',
    data: 'SHOP_ID',
  },
  {
    title: 'ชื่อจุดติดตั้ง/ชื่อร้านค้า',
    data: 'SHOP_NAME_TH',

  },
  {
    title: 'ผู้กระทำการแทน',
    data: 'CONTACT_NAME_TH',

  },
  {
    title: 'เบอร์โทร',
    data: 'MOBILE',

  },
  {
    title: 'ชื่อนิติบุคคล/ชื่อบุคคล',
    data: 'SHOP_TAX_NAME_TH',

  },
  {
    title: 'ชื่อ CD',
    data: 'BY_NAME',

  },
  {
    title: 'STATUS',
    data: 'STATUS',
    render: function (data, type, row) {
      if (type === 'display') {
        if (row.STATUS === '') {
          return `<input class="btn btn-primary btn-xs m-1" type="button" value="on process" disabled>`;
        }
        if (row.STATUS === 'AP') {
          return `<input class="btn btn-success btn-xs m-1" type="button" value="complete" disabled>`;
        }
        if (row.STATUS === 'WA') {
          return `<input class="btn btn-warning btn-xs m-1" type="button" value="waiting" disabled>`;
        }
        if (row.STATUS === 'RJ') {
          return `<input class="btn btn-danger btn-xs m-1" type="button" value="rejected" disabled>`;
        }
      }
      return data;
    }
  },
  {
    title: 'VIEW',
    data: 'SHOP_ID',
    render: function (data, type, row) {
      // console.log('Render View:', data); // ดูว่ามีค่าหรือไม่
      if (type === 'display') {
        return `
          <a class="btn btn-outline-secondary btn-sm" id="${row.SHOP_ID}_view">
            <i class="fas fa-search"></i>
          </a>`;
      }
      return data;
    }
  },
  {
    title: 'PRINT',
    data: 'PRINT_URL',
    render: function (data, type, row) {
      // console.log('Render View:', data, 'Status:', row.STATUS);
      if (type === 'display') {
        if (row.STATUS === 'RJ') return ''; // กรณีเป็น 'RJ' ไม่ต้องแสดงอะไรเลย
        if (row.STATUS === 'AP' || row.STATUS === 'WA') {
          return `
                <a class="btn btn-outline-success btn-sm" id="${row.SHOP_ID}_pnt" target="_blank" href="${data}">
                    <i class="fas fa-print"></i>
                </a>`;
        }
      }
      return data;
    }
  },
  // {
  //   title: 'ZOOM',
  //   data: 'SHOP_ID',
  //   render: function (data, type, row) {
  //     // console.log('Render View:', data); // ดูว่ามีค่าหรือไม่
  //     if (type === 'display') {
  //       if (row.STATUS === 'RJ')
  //         return `</>`;
  //       if (row.STATUS === 'AP' || row.STATUS === 'WA')
  //         // return `
  //         // <a class="btn btn-outline-primary btn-sm" id="${row.SHOP_ID}_zoom" >
  //         //   <i class="fas fa-video"></i>
  //         // </a>`;
  //         return `
  //         <a class="btn btn-outline-primary btn-sm" target="_blank" id="${row.SHOP_ID}_temp" href="http://localhost:3002/fp-zoom?shopid=${row.SHOP_ID}">
  //           <i class="fas fa-video"></i>
  //         </a>`;

  //     }
  //     return data;
  //   }
  {
    title: 'ZOOM',
    data: 'SHOP_ID',
    render: function (data, type, row) {
      if (type === 'display') {
        if (row.STATUS === 'RJ') return '';
        if (row.STATUS === 'AP' || row.STATUS === 'WA') {
          return `
          <a href="#" class="btn btn-outline-primary btn-sm" id="${row.SHOP_ID}_zoom">
            <i class="fas fa-video"></i>
          </a>`;
        }
      }
      return data;
    }
  }
];

function reloadTableData(items, page, filter) {
  console.log('reload: ' + items.length);
  console.log('page: ' + page);
  const table = $(`#${0}`).DataTable();
  //   const table = $(`table.example`).DataTable();
  table.clear();
  table.rows.add(items);
  table.draw();
  console.log('filter: ' + filter);
  table.search(filter);
  table.page(page).draw('page');
  setTimeout(function () {
    table.columns.adjust();
  }, 50);
}

function updateTable(items, page) {
  console.log('update: ' + items.length);
  const table = $(`#${0}`).DataTable();
  let dataChanged = false;
  table.rows().every(function () {
    const oldNameData = this.data();
    const newNameData = items.find((item) => {
      return item.SHOP_ID === oldNameData.SHOP_ID;
    });

    if (oldNameData.lastUpdate !== newNameData.lastUpdate) {
      dataChanged = true;
      this.data(newNameData);
    }
    return true;
  });

  console.log(dataChanged);
  if (dataChanged) {
    //table.draw();
    table.page(page).draw('page');
  }
}

class TableMyshop extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const table = $(`#${0}`).DataTable({
      data: this.props.items,
      dom: 'Bfrtip',
      columns,
      searching: true,
      order: [[0, 'desc']], //1
      columnDefs: [{ target: 0, visible: false }],
      paging: true,
      ordering: true,
      autoWidth: true,
      bDestroy: true,
      pageLength: 10,
      scrollX: true,
      buttons: [
        'copy',
        {
          extend: 'csv',
          title: `data_report_csv_${Date.now()}`
        },
        {
          extend: 'excelHtml5',
          title: `data_report_excel_${Date.now()}`
        }
      ],
      search: {
        search: this.props.filter
      }

    });

    // Event Listener สำหรับปุ่ม View
    $(`#${0} tbody`).on('click', 'a', async (event) => {
      var $this = $(event.currentTarget);
      var data = table.row($this.parents('tr')).data();
      if ($this.attr('id').split('_')[1] === 'view') {
        this.props.onToggle(data); // ส่งข้อมูลไปที่ฟังก์ชัน onToggle
      }
      if ($this.attr('id').split('_')[1] === 'zoom') {
        var res = await this.props.onZoom(data.SHOP_ID); // ส่งข้อมูลไปที่ฟังก์ชัน onToggle
        // window.location.href = res.zoom_join_url;
        if (res === null || res.zoom_join_url === null) {
          window.location.href = '/login';
        }
        // window.open(res.zoom_join_url, '_blank').focus();
        // window.open(res.zoom_join_url, '_self').focus();
        window.location.href = res.zoom_join_url;
      }
    });

    // $(`#${0} tbody`).on('click', 'a', async (event) => {
    //   event.preventDefault(); // 🚫 ป้องกันไม่ให้ลิงก์ # เด้งหน้า

    //   var $this = $(event.currentTarget);
    //   var data = table.row($this.parents('tr')).data();
    //   const action = $this.attr('id').split('_')[1];

    //   if (action === 'view') {
    //     this.props.onToggle(data);
    //   }

    //   if (action === 'zoom') {
    //     try {
    //       const res = await this.props.onZoom(data.SHOP_ID); // 👉 เรียก fatchZoomData
    //       if (!res || !res.zoom_join_url) {
    //         window.location.href = '/login';
    //         return;
    //       }
    //       // ✅ เปิด URL ที่ได้จาก API
    //       // window.open(res.zoom_join_url, '_blank');
    //       window.location.href = res.zoom_join_url;

    //     } catch (err) {
    //       console.error('❌ Zoom API Error', err);
    //       window.location.href = '/login';
    //     }
    //   }
    // });


    // Event Listener สำหรับปุ่มอื่น ๆ (ถ้าจำเป็น เช่น Print, QR)
    $(`#${0} tbody`).on('click', 'a', (event) => {
      const $this = $(event.currentTarget);
      const data = table.row($this.parents('tr')).data();
      if ($this.attr('id').includes('_print')) {
        console.log('Print Clicked:', data); // Debug
        this.props.onPrintToggle(data); // เรียกฟังก์ชัน Print
      } else if ($this.attr('id').includes('_qr')) {
        console.log('QR Clicked:', data); // Debug
        this.props.onQrToggle(data); // เรียกฟังก์ชัน QR
      }
    });

    table.on('page', (event) => {
      const info = table.page.info();
      this.props.onPageChange(info.page); // อัปเดตเพจ
    });

    table.on('search.dt', (event) => {
      console.log(table.search());
      // if (this.props.onTest){
      //   this.props.onTest();
      // }
      this.props.setFilter(table.search());
      // $('#filterInfo').html('Currently applied global search: ' + table.search());
    });
  }


  componentWillUnmount() {
    $(`#${0}`).DataTable().destroy(true);
  }

  shouldComponentUpdate(nextProps) {
    // if (nextProps.items.length !== this.props.items.length) {
    reloadTableData(nextProps.items, nextProps.page, nextProps.filter);
    // } else {
    // updateTable(nextProps.items, nextProps.page);
    // }
    return true;
  }

  render() {
    return (
      <div >
        <Card className="card-primary">
          {/* <div className={this.props.show ? 'd-none' : 'overlay dark'}>
            <span style={{color: 'white', fontSize: 30}}>CR ONLY</span>
          </div> */}
          <Card.Header>รายการของคุณทั้งหมด</Card.Header>
          <Card.Body>
            <table
              ref="main"
              className="display nowrap example"
              id={0}
              style={{ width: '100%' }}
            />
          </Card.Body>
        </Card>
      </div>
    );
  }
}
export default TableMyshop;
